import { render } from "./SplitHeader.vue?vue&type=template&id=21b7a9ac&scoped=true"
import script from "./SplitHeader.vue?vue&type=script&lang=js"
export * from "./SplitHeader.vue?vue&type=script&lang=js"

import "./SplitHeader.vue?vue&type=style&index=0&id=21b7a9ac&lang=scss&scoped=true"

import exportComponent from "/home/wildan/Projects/assets-tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b7a9ac"]])

export default __exports__